import React from 'react';
import Layout from '../components/Layout';

const SecurityTest = () => {
  return (
    <Layout>
      <div className="max-w-7xl mx-auto">
        <h1 className="text-3xl font-bold mb-8">Security Features Test</h1>
        
        <div className="bg-white shadow-md rounded-lg p-6 mb-6">
          <h2 className="text-xl font-semibold mb-4">Print Prevention Test</h2>
          <p className="mb-4">Try to print this page using Ctrl+P or Cmd+P. The content should be hidden.</p>
          <button 
            onClick={() => window.print()}
            className="px-3 py-1.5 text-sm bg-blue-600 text-white rounded hover:bg-blue-700"
          >
            Test Print
          </button>
        </div>

        <div className="bg-white shadow-md rounded-lg p-6 mb-6">
          <h2 className="text-xl font-semibold mb-4">Screenshot Prevention Test</h2>
          <p className="mb-4">Try to take a screenshot using:</p>
          <ul className="list-disc list-inside mb-4">
            <li>Print Screen key</li>
            <li>Alt + Print Screen</li>
            <li>Windows + Shift + S (Windows)</li>
            <li>Cmd + Shift + 3/4 (Mac)</li>
          </ul>
          <p>You should see an alert when attempting to take a screenshot.</p>
        </div>

        <div className="bg-white shadow-md rounded-lg p-6 mb-6">
          <h2 className="text-xl font-semibold mb-4">Content Protection Test</h2>
          <p className="mb-4">This content is protected with the following features:</p>
          <ul className="list-disc list-inside">
            <li>Watermark overlay (visible in background)</li>
            <li>Right-click disabled</li>
            <li>Text selection disabled (except in input fields)</li>
            <li>Copy/paste prevention</li>
            <li>Developer tools warning</li>
          </ul>
        </div>

        <div className="bg-white shadow-md rounded-lg p-6">
          <h2 className="text-xl font-semibold mb-4">Input Field Test</h2>
          <p className="mb-4">Text selection should work in input fields:</p>
          <input 
            type="text" 
            placeholder="Try selecting text here"
            className="w-full border border-gray-300 focus:border-transparent focus:outline-none focus:ring-2 focus:ring-primary-500 py-1.5 rounded-lg px-3 text-sm"
          />
        </div>
      </div>
    </Layout>
  );
};

export default SecurityTest;